<template>
  <div class="container has-text-centered">
      <h3 class="title has-text-grey">Formulario de Actualización</h3>
      <formulario-actualizar></formulario-actualizar>
  </div>
</template>

<script>
import {mapGetters} from "vuex"
import FormularioActualizar from "@/components/FormularioActualizar.vue";
export default {
  name: "Actualización",
  components: {
    FormularioActualizar
  },
  data: function() {
    return {};
  },
  computed: {
    ...mapGetters({
      estrategia: "getEstrategia"
    })
  },
  methods: {},
  mounted() {}
};
</script>

<style></style>
